const mainConfig = {
	development: false,
	//CMS_BASE_URL: "https://berlinerzwischentoene.de",
	//CMS_BASE_URL: "http://92.243.27.23",
	//CMS_BASE_URL: "https://berlinerzwischentoene.de",
	CMS_BASE_URL: "https://api.stadtmodell-potsdam-1912.de",
};
module.exports = mainConfig;
